import Vue from 'vue';
import {Prop} from 'vue/types/options';
import {mapGetters, mapState} from 'vuex';
import {AxiosResponse} from 'axios';
import {EmployeeProfileModuleConstant, EventConstant, UrlModuleConstant} from '../../lib/constants';
import PtClientListResults from './ptClientListResults.html';
import MomentFilter from '../../lib/filters/momentFilter';
import {coachService} from '../../lib/services/coachService';
import TrainerizeUrlService from '../../lib/services/trainerizeUrlService';
import EcCommon from '../../../types/ec/ecCommon';
import PtClientList from '../../../types/ec/ecPtClientList';
import LtCommon from '../../../types/lt/ltCommon';
import EventHub from '../../lib/eventHub';

interface IComponentData {
	clientPartyId: number;
	clubId: number;
}

export default Vue.component('ecPtClientListResults', {
	template: PtClientListResults,
	data(): IComponentData {
		return {
			clientPartyId: 0,
			clubId: 0,
		};
	},
	props: {
		clients: Array as Prop<PtClientList.IClientSummary[]>,
	},
	computed: {
		...mapGetters(EmployeeProfileModuleConstant.name,  {
			getIsEmployeeProfileValid: EmployeeProfileModuleConstant.getter.getIsValid,
		}),
		...mapGetters(UrlModuleConstant.name, [UrlModuleConstant.getter.getGlobalPageDriverUrl]),
		...mapState(EmployeeProfileModuleConstant.name, [EmployeeProfileModuleConstant.state.employeeProfile]),
	},
	methods: {
		viewTrainingProgram(client: PtClientList.IClientSummary): Promise<void> {
			const newWindow: Window = window.open('', '_blank') as Window;
			return Promise.all([coachService.getSSOForTrainerize(this.employeeProfile.partyId), coachService.getClientUserIdInTrainerize(client.partyId)])
				.then((response: AxiosResponse<EcCommon.ITrainerizeToken | EcCommon.IClientUserId>[]) => {
					const params: LtCommon.IParamsObject = {
						url: 'trainingplan',
						clientid: (response[1].data as EcCommon.IClientUserId).userID,
						logintoken: (response[0].data as EcCommon.ITrainerizeToken).token,
						userID: (response[0].data as EcCommon.ITrainerizeToken).sourceId,
					};

					const trainerizeUrl = TrainerizeUrlService.getTrainerizeUrl(params);
					newWindow.location.assign(trainerizeUrl);
				});
		},
		showDisconnectClientModal(index: number, client: PtClientList.IClientSummary): void {
			this.clientPartyId = client.partyId;
			this.clubId = client.clubId;
			$('#disconnectClientModal' + index).modal('show');
		},
		disconnectClient(index: number): Promise<void> {
			$('#disconnectClientModal' + index).modal('hide');
			return coachService.setClientDisconnect(this.employeeProfile.partyId, this.clientPartyId, this.clubId)
				.then((response: AxiosResponse<void>) => {
					EventHub.$emit(EventConstant.GetClientLists, this.clientPartyId);
				});
		},
	},
	filters: {
		momentFilter: MomentFilter,
	},
});
